import { useState } from 'react';
import PropTypes from 'prop-types';
import { ArrowLink, EsgLogo, Modal, CloudinaryPicture } from '@bwoty-web/ui-kit';
import LinkPush from './linkPush';
import './esgCertified.scss';

const EsgCertified = ({ labels }) => {
  const [popUpOpen, openPopUp] = useState(false);

  if (!labels) {
    return null;
  }

  return (
    <>
      <LinkPush aria-haspopup='dialog' onClick={() => openPopUp(true)}>
        <EsgLogo className="gw-esg-certified-logo" esgType="landscape" />
        <span>{labels?.labelHotelPage}</span>
      </LinkPush>
      <Modal
        isOpen={popUpOpen}
        onClose={() => openPopUp(false)}
        heading={`${labels?.titlePopup}`}
        size="m"
      >
        <div className="gw-hotel-esg-pop-up-content">
          <div className="gw-hotel-esg-pop-up-content__push">
            <CloudinaryPicture
              className="gw-hotel-esg-pop-up-content__image"
              img={labels?.firstPushImg.media}
              alt={labels?.firstPushImg?.alt}
              sizes={[
                {
                  width: 400,
                },
              ]}
              lazy
            />
            <div>
              <h3>{labels?.firstPushHeadline}</h3>
              <p>{labels?.firstPushText}</p>
              {labels?.firstPushLink && (
                <ArrowLink
                  href={labels?.firstPushLink?.href?.url}
                  target={labels?.firstPushLink?.href?.target || '_self'}
                >
                  {labels?.firstPushLink?.title}
                </ArrowLink>
              )}
            </div>
          </div>
          <div className="gw-hotel-esg-pop-up-content__push">
            <CloudinaryPicture
              className="gw-hotel-esg-pop-up-content__image"
              img={labels?.secondPushImg?.media}
              alt={labels?.secondPushImg?.alt}
              sizes={[
                {
                  width: 400,
                },
              ]}
              lazy
            />
            <div>
              <h3>{labels?.secondPushHeadline}</h3>
              <p>{labels?.secondPushText}</p>
              <ArrowLink
                href={labels?.secondPushLink?.href?.url}
                target={labels?.secondPushLink?.href?.target || '_self'}
              >
                {labels?.secondPushLink?.title}
              </ArrowLink>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

EsgCertified.propTypes = {
  labels: PropTypes.shape({
    firstPushImg: PropTypes.shape({
      alt: PropTypes.string,
      sources: PropTypes.arrayOf(PropTypes.shape({})),
      media: PropTypes.shape({}),
    }),
    secondPushImg: PropTypes.shape({
      alt: PropTypes.string,
      sources: PropTypes.arrayOf(PropTypes.shape({})),
      media: PropTypes.shape({}),
    }),
    labelHotelPage: PropTypes.string,
    titlePopup: PropTypes.string,
    firstPushHeadline: PropTypes.string,
    firstPushText: PropTypes.string,
    firstPushLink: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.shape({
        url: PropTypes.string,
        target: PropTypes.string,
      }),
    }),
    secondPushHeadline: PropTypes.string,
    secondPushText: PropTypes.string,
    secondPushLink: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.shape({
        url: PropTypes.string,
        target: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default EsgCertified;
